module.exports = __webpack_public_path__ + "static/media/highway@2x.1dda9f5e.png";